import React from 'react';
import { Bar } from 'react-chartjs-2';

export default class Chartf extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const options = {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: true,
        },
      },
      scales: {
        
        y: {
          stacked: true,
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
          },
          ticks: {
            display: true,
            padding: 10,
            color: "#9ca2b7",
            font: {
              size: 11,
              //family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
          },
        },
        x: {
          stacked: true,
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: true,
            drawTicks: true,
          },
          ticks: {
            display: true,
            color: "#9ca2b7",
            padding: 10,
            font: {
              size: 11,
              //family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
    }

    return <Bar className={'padding-top-30'} data={this.props.data} options = {options} />;
  }
}
